/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ capability: NonNullable<unknown> }} Rights_Action_Menu_LabelInputs */



/**
* | output |
* | --- |
* | "Set for {capability}" |
*
* @param {Rights_Action_Menu_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_action_menu_label = /** @type {((inputs: Rights_Action_Menu_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Action_Menu_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Für ${i?.capability} festlegen`)
	return /** @type {LocalizedString} */ (`Set for ${i?.capability}`)
});